import { pdf } from '@react-pdf/renderer';
import React from 'react';

/**
 * Exports a React component to PDF and triggers a download
 * @param pdfDocument - The React component to render as PDF
 * @param fileName - The filename for the downloaded PDF (without .pdf extension)
 */
export const exportToPDF = async (pdfDocument: React.ReactElement, fileName: string) => {
    try {
        const blob = await pdf(pdfDocument).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${fileName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error generating PDF:', error);
        throw error;
    }
};
